import "./PreAccessInventoryTab.css";

import { getInventoryUnitLabel } from "../../../../../../../utils";
import { Column, CursorDataGrid, InventoryChartKey, Row, StackedBarChart } from "../../../../../../../widget";
import { PRE_ACCESS_TOTAL_COLUMN_NAMES } from "./constants/preAccessInventoryTab.constants";
import { PreAccessInventoryTabProps } from "./models/preAccessInventoryTab.models";
import { usePreAccessInventoryTab } from "./usePreAccessInventoryTab";

export const PreAccessInventoryTab = ({ projectUuid, unitMeasurement }: PreAccessInventoryTabProps): JSX.Element => {
  const {
    columns,
    defaultSortingCriteria,
    hasData,
    hasEnoughIssuancesForScrolling,
    isLoading,
    onChange,
    stackedChartData,
    xAxisLabels,
    chartKeyNutrients,
    showAvailable,
  } = usePreAccessInventoryTab({
    projectUuid,
    unitMeasurement,
  });

  /*
    D-4 - Nutrient Neutrality quantities are an annual rate, so the axis and the tooltip carry the
    unit. Undefined for every other measurement, which leaves their chart options untouched: the
    tooltip below then falls back to StackedBarChart's own `label: value` callback.
  */
  const unitLabel = getInventoryUnitLabel(unitMeasurement);

  return (
    <div className="ProjectTabSection PreAccessInventoryTab">
      <Row spacingV="ll">
        <Column span={12}>
          <h2>Inventory</h2>
        </Column>
      </Row>
      {stackedChartData && xAxisLabels && hasData && (
        <Row spacingV="2xl">
          <Column span={12}>
            <StackedBarChart
              xLabels={xAxisLabels}
              data={stackedChartData}
              hasYAxisGridLines
              hasYAxisTicks
              showLegend={false}
              yAxisTitle={unitLabel}
              customTooltipLabel={
                unitLabel ? (context) => `${context.dataset.label}: ${context.parsed.y}${unitLabel}` : undefined
              }
            />
            <InventoryChartKey
              surface="assetManagerPreAccess"
              unitMeasurement={unitMeasurement}
              showAvailable={showAvailable}
              nutrients={chartKeyNutrients}
            />
          </Column>
        </Row>
      )}
      <Row spacingV={hasEnoughIssuancesForScrolling ? "ml" : undefined}>
        <Column span={12}>
          <div className={`ProjectInventoryDataGrid ${hasEnoughIssuancesForScrolling ? "Scrollable" : ""}`}>
            <CursorDataGrid
              columns={columns}
              clientSide={false}
              filterable
              showFilterToggle
              sortable
              onChange={onChange}
              data={[]}
              dataIsLoading={isLoading}
              noDataMessage="No inventory to display"
              pagination={{ pageSize: 1000 }}
              hasTotalRow
              totalColumnNames={PRE_ACCESS_TOTAL_COLUMN_NAMES}
              defaultSortingCriteria={defaultSortingCriteria}
              infiniteScroll
              variant="seed"
            />
          </div>
        </Column>
      </Row>
    </div>
  );
};
